define(['modules/common/controls/control'], (Control) => Control.extend({

    binders: {
        value: {
            bind (view, publish) {
                this.callback = function () {
                    publish(view.get());
                };
                view.on('change', this.callback);
            },
            unbind (view) {
                view.off('change', this.callback);
            },
            routine (view, value) {
                view.set(value);
            }
        },
        toggle (view, value) {
            view.$el.toggle(Boolean(value));
        }
    },

    className: 'btn-group',

    events: {
        'click button': 'buttonClick'
    },

    defaults: _.extend({
        id: 'id',
        text: 'name'
    }, Control.prototype.defaults),

    initialize () {
        Control.prototype.initialize.apply(this, arguments);
        this.choices = this.options.choices;
    },

    render () {
        this.$el.empty().append(this.choices.toJSON().map(function (item) {
            return $('<button>').addClass('btn btn-default').
                html(this.formatChoice(item));
        }, this));

        return this;
    },

    formatChoice (item) {
        return item[this.options.text];
    },

    get () {
        return _.chain(_.zip(this.choices.models, this.$('button').get())).filter((item) => $(item[1]).is('.active')).
            map((item) => item[0].id).
            value();
    },

    set (values) {
        _.each(_.zip(this.choices.models, this.$('button').get()), (item) => {
            $(item[1]).toggleClass('active', _.indexOf(values, item[0].id) >= 0);
        });
    },

    buttonClick (event) {
        $(event.currentTarget).toggleClass('active');
        this.trigger('change');
        return false;
    }
}));
